"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusEnum = void 0;
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["SUCCEED"] = "Success";
    StatusEnum["FAILED"] = "Failed";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
